import { generateUnlayerDesign } from "../utils";

import type { Database, DatabaseWithOptions } from "../../../__definitions__/database-definitions";
import type {
  UnlayerDesign,
  UnlayerDesignBlock,
} from "../../unlayer-email-content/types/unlayer-design";
import type { PostgrestClient } from "@supabase/postgrest-js";

export class SupabaseUnlayerDesignLoader {
  readonly supabase: PostgrestClient<DatabaseWithOptions["db"], DatabaseWithOptions["options"]>;
  constructor(
    supabase: PostgrestClient<DatabaseWithOptions["db"], DatabaseWithOptions["options"]>,
  ) {
    this.supabase = supabase;
  }

  async loadNew(): Promise<UnlayerDesign> {
    const { header, footer } = await this.getBlock();

    return this.generateDesign(header, footer, this.contentPlaceholderBlock());
  }

  async loadFromLibrary(
    moment: Database["public"]["Tables"]["email_moment"]["Row"],
  ): Promise<UnlayerDesign> {
    const { design } = moment;
    const { header, footer } = await this.getBlock();

    return this.generateDesign(header, footer, design?.body?.rows ?? []);
  }

  loadExisting(moment: {
    design: UnlayerDesign | undefined | null;
  }): UnlayerDesign | undefined | null {
    return moment.design;
  }

  async getBlock(): Promise<{
    header: UnlayerDesignBlock[];
    footer: UnlayerDesignBlock[];
  }> {
    const { data } = await this.supabase
      .from("account")
      .select("email_moment_header, email_moment_footer")
      .single();
    if (!data) {
      return { header: [], footer: [] };
    }
    return {
      header: data.email_moment_header ?? [],
      footer: data.email_moment_footer ?? [],
    };
  }

  generateDesign(
    header: UnlayerDesignBlock[],
    footer: UnlayerDesignBlock[],
    design: UnlayerDesignBlock[],
  ): UnlayerDesign {
    return generateUnlayerDesign(header, footer, design);
  }

  contentPlaceholderBlock(): UnlayerDesignBlock[] {
    // oxlint-disable-next-line typescript/no-unsafe-type-assertion
    return [
      {
        id: "WMcNiBSEJD",
        cells: [1],
        columns: [
          {
            id: "efCR0nXLxA",
            contents: [
              {
                id: "kFbIMaPP62",
                type: "heading",
                values: {
                  containerPadding: "9px 30px 40px 31px",
                  anchor: "",
                  headingType: "h1",
                  fontFamily: {
                    label: "Open Sans",
                    value: "'Open Sans',sans-serif",
                    url: "https://fonts.googleapis.com/css?family=Open+Sans:400,700",
                    defaultFont: true,
                  },
                  fontSize: "26px",
                  color: "#023047",
                  textAlign: "center",
                  lineHeight: "170%",
                  linkStyle: {
                    inherit: true,
                    linkColor: "#0000ee",
                    linkHoverColor: "#0000ee",
                    linkUnderline: true,
                    linkHoverUnderline: true,
                  },
                  hideDesktop: false,
                  displayCondition: null,
                  _styleGuide: null,
                  _meta: {
                    htmlID: "u_content_heading_6",
                    htmlClassNames: "u_content_heading",
                  },
                  selectable: true,
                  draggable: true,
                  duplicatable: true,
                  deletable: true,
                  hideable: true,
                  locked: false,
                  text: "<strong>Insert a title here</strong>",
                },
              },
              {
                id: "fsop-VNlDR",
                type: "paragraph",
                values: {
                  textJson:
                    '{"root":{"children":[{"children":[{"detail":0,"format":1,"mode":"normal","style":"","text":"Hi [add merge tag here],","type":"extended-text","version":1}],"direction":null,"format":"","indent":0,"type":"extended-paragraph","version":1,"textFormat":1,"textStyle":"","isInlineTool":false},{"children":[{"detail":0,"format":0,"mode":"normal","style":"","text":" ","type":"extended-text","version":1}],"direction":null,"format":"","indent":0,"type":"extended-paragraph","version":1,"textFormat":0,"textStyle":"","isInlineTool":false},{"children":[{"detail":0,"format":0,"mode":"normal","style":"","text":"Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. ","type":"extended-text","version":1}],"direction":null,"format":"","indent":0,"type":"extended-paragraph","version":1,"textFormat":0,"textStyle":"","isInlineTool":false},{"children":[{"detail":0,"format":0,"mode":"normal","style":"","text":" ","type":"extended-text","version":1}],"direction":null,"format":"","indent":0,"type":"extended-paragraph","version":1,"textFormat":0,"textStyle":"","isInlineTool":false},{"children":[{"detail":0,"format":1,"mode":"normal","style":"","text":"Voluptate velit esse cillum dolore eu fugiat nulla pariatur:","type":"extended-text","version":1}],"direction":null,"format":"","indent":0,"type":"extended-paragraph","version":1,"textFormat":1,"textStyle":"","isInlineTool":false},{"children":[{"children":[{"detail":0,"format":1,"mode":"normal","style":"","text":"Lorem ipsum dolor sit amet, consectetur","type":"extended-text","version":1}],"direction":null,"format":"","indent":0,"type":"extended-listitem","version":1,"value":1},{"children":[{"detail":0,"format":1,"mode":"normal","style":"","text":"Lorem ipsum dolor sit amet, consectetur adipiscing","type":"extended-text","version":1}],"direction":null,"format":"","indent":0,"type":"extended-listitem","version":1,"value":2},{"children":[{"detail":0,"format":1,"mode":"normal","style":"","text":"Lorem ipsum dolor sit amet, consectetur adipiscing elit","type":"extended-text","version":1}],"direction":null,"format":"","indent":0,"type":"extended-listitem","version":1,"value":3}],"direction":null,"format":"","indent":0,"type":"extended-list","version":1,"listType":"bullet","start":1,"tag":"ul"}],"format":"","indent":0,"type":"root","version":1}}',
                  containerPadding: "10px",
                  anchor: "",
                  fontSize: "14px",
                  textAlign: "left",
                  lineHeight: "140%",
                  linkStyle: {
                    inherit: true,
                    linkColor: "#0000ee",
                    linkHoverColor: "#0000ee",
                    linkUnderline: true,
                    linkHoverUnderline: true,
                  },
                  displayCondition: null,
                  _styleGuide: null,
                  _meta: {
                    htmlID: "u_content_paragraph_1",
                    htmlClassNames: "u_content_paragraph",
                  },
                  selectable: true,
                  draggable: true,
                  duplicatable: true,
                  deletable: true,
                  hideable: true,
                  locked: false,
                  _languages: {},
                  text: '<p><span style="font-weight: bold">Hi [add merge tag here],</span></p><p><span>&nbsp;</span></p><p><span>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.&nbsp;</span></p><p><span>&nbsp;</span></p><p><span style="font-weight: bold">Voluptate velit esse cillum dolore eu fugiat nulla pariatur:</span></p><ul><li><span style="font-weight: bold">Lorem ipsum dolor sit amet, consectetur</span></li><li><span style="font-weight: bold">Lorem ipsum dolor sit amet, consectetur adipiscing</span></li><li><span style="font-weight: bold">Lorem ipsum dolor sit amet, consectetur adipiscing elit</span></li></ul>',
                },
              },
              {
                id: "gqmwrGu9he",
                type: "button",
                values: {
                  href: {
                    name: "web",
                    values: {
                      href: "https://www.google.com",
                      target: "_blank",
                    },
                    attrs: {
                      href: "{{href}}",
                      target: "{{target}}",
                    },
                  },
                  buttonColors: {
                    color: "#FFFFFF",
                    backgroundColor: "#33428d",
                    hoverColor: "#FFFFFF",
                    hoverBackgroundColor: "#3AAEE0",
                  },
                  size: {
                    autoWidth: true,
                    width: "100%",
                  },
                  fontSize: "14px",
                  lineHeight: "120%",
                  textAlign: "center",
                  padding: "20px 70px",
                  border: {},
                  borderRadius: "44px",
                  hideDesktop: false,
                  displayCondition: null,
                  _styleGuide: null,
                  containerPadding: "20px 10px 30px",
                  anchor: "",
                  _meta: {
                    htmlID: "u_content_button_1",
                    htmlClassNames: "u_content_button",
                  },
                  selectable: true,
                  draggable: true,
                  duplicatable: true,
                  deletable: true,
                  hideable: true,
                  locked: false,
                  text: "<strong><span style=\"font-size: 14px; line-height: 16.8px; font-family: 'Open Sans', sans-serif;\">BUTTON TEXT</span></strong>",
                  calculatedWidth: 236,
                  calculatedHeight: 57,
                },
                hasDeprecatedFontControls: true,
              },
              {
                id: "zawsb6hnlL",
                type: "paragraph",
                values: {
                  textJson:
                    '{"root":{"children":[{"children":[{"detail":0,"format":0,"mode":"normal","style":"","text":"At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas.","type":"extended-text","version":1}],"direction":null,"format":"","indent":0,"type":"extended-paragraph","version":1,"textFormat":0,"textStyle":"","isInlineTool":false},{"children":[{"detail":0,"format":0,"mode":"normal","style":"","text":" ","type":"extended-text","version":1}],"direction":null,"format":"","indent":0,"type":"extended-paragraph","version":1,"textFormat":0,"textStyle":"","isInlineTool":false},{"children":[{"detail":0,"format":0,"mode":"normal","style":"","text":"Molestias excepturi sint occaecati cupiditate non provident.","type":"extended-text","version":1}],"direction":null,"format":"","indent":0,"type":"extended-paragraph","version":1,"textFormat":0,"textStyle":"","isInlineTool":false},{"children":[{"detail":0,"format":0,"mode":"normal","style":"","text":" ","type":"extended-text","version":1}],"direction":null,"format":"","indent":0,"type":"extended-paragraph","version":1,"textFormat":0,"textStyle":"","isInlineTool":false},{"children":[{"detail":0,"format":0,"mode":"normal","style":"","text":"With Regards,","type":"extended-text","version":1}],"direction":null,"format":"","indent":0,"type":"extended-paragraph","version":1,"textFormat":0,"textStyle":"","isInlineTool":false},{"children":[{"detail":0,"format":1,"mode":"normal","style":"","text":"[your name]","type":"extended-text","version":1}],"direction":null,"format":"","indent":0,"type":"extended-paragraph","version":1,"textFormat":1,"textStyle":"","isInlineTool":false}],"format":"","indent":0,"type":"root","version":1}}',
                  containerPadding: "10px",
                  anchor: "",
                  fontSize: "14px",
                  textAlign: "left",
                  lineHeight: "140%",
                  linkStyle: {
                    inherit: true,
                    linkColor: "#0000ee",
                    linkHoverColor: "#0000ee",
                    linkUnderline: true,
                    linkHoverUnderline: true,
                  },
                  displayCondition: null,
                  _styleGuide: null,
                  _meta: {
                    htmlID: "u_content_paragraph_2",
                    htmlClassNames: "u_content_paragraph",
                  },
                  selectable: true,
                  draggable: true,
                  duplicatable: true,
                  deletable: true,
                  hideable: true,
                  locked: false,
                  _languages: {},
                  text: '<p><span>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas.</span></p><p><span>&nbsp;</span></p><p><span>Molestias excepturi sint occaecati cupiditate non provident.</span></p><p><span>&nbsp;</span></p><p><span>With Regards,</span></p><p><span style="font-weight: bold">[your name]</span></p>',
                },
              },
            ],
            values: {
              _meta: {
                htmlID: "u_column_12",
                htmlClassNames: "u_column",
              },
              backgroundColor: "#ffffff",
              deletable: true,
            },
          },
        ],
        values: {
          displayCondition: null,
          columns: false,
          _styleGuide: null,
          backgroundColor: "",
          columnsBackgroundColor: "",
          backgroundImage: {
            url: "",
            fullWidth: true,
            repeat: "no-repeat",
            size: "custom",
            position: "top-center",
            customPosition: ["50%", "0%"],
          },
          padding: "0px",
          anchor: "",
          hideDesktop: false,
          _meta: {
            htmlID: "u_row_11",
            htmlClassNames: "u_row",
          },
          selectable: true,
          draggable: true,
          duplicatable: true,
          deletable: true,
          hideable: true,
          locked: false,
        },
      },
    ] as unknown as UnlayerDesignBlock[];
  }
}
